import * as query from "@arcgis/core/rest/query.js";

export default function getFloodZoneInfo(geometry) {
  return new Promise((resolve, reject) => {
    try {

        query.executeQueryJSON("https://maps.wingis.org/public/rest/services/NFHL_FEMAFloodZones/MapServer" + "/2", {
          geometry: geometry,
         // outFields: ["SFHA_TF", "FLD_ZONE"],
          outFields: ["*"],
          returnGeometry: false, 
          spatialRelationship: "intersects"
        })
        .then((results) => {
          resolve(results);
        })
        .catch((error) => {

          reject(new Error(`Query execution failed: ${error.message}`));
        });
    
    } catch (error) {

      reject(new Error(`Failed to load query module: ${error.message}`));
    }
  });
}
